module.exports = __webpack_public_path__ + "static/media/ic_rubber_selected.3276a44c.svg";